<template>
  <Button v-bind="$attrs" v-on="$listeners">
    {{ label }}
    <slot />
  </Button>
</template>

<script>
import { Button } from "ant-design-vue";

export default {
  components: {
    Button
  },
  props: {
    label: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="scss" scoped>
button {
  padding: 0 30px;
  line-height: 40px;
  height: 40px;
}
</style>
